import '../../../../../stylesheets/global/loading.css'
import '../../../../../stylesheets/nav/profile-popover.css'
import { useState, useEffect, useRef }          from     'react'
import { graphicPro, graphicFree, checkIcon }   from '../drawings.js'
import { useSubscription }                      from "../../../../../hooks/external/proprietary/handlers/useSubscription.js"


const SubscriptionCards = () => {
/*
EX shape of paid sub: paymentMethod object w/ direct CC (no google or apply pay)
paymentMethod = {
    paymentStatus: true,
    ccBrand: "visa",
    ccLast4: "4242",
    wallet: false,     
}

EX shape of non-paid sub: paymentMethod object
paymentMethod = {
    paymentStatus: false
}

EX shape of paid sub: subscription object
subscription = {
    paymentStatus: true,
    renewalDate: 1810077294000,
}

EX shape of non-paid sub: subscription object
paymentMethod = {
    paymentStatus: false
}
*/
    // == hooks ==
    const { handleFetchCheckoutSessionURL } = useSubscription()
    
    // == stateful vars ==
    const [isLoading, setIsLoading] = useState(false)

    // == local vars ==
    const tiers = [
        {
            upgradeCard:            false,
            graphic:         graphicFree,
            tierName:        'Entry Plan',
            tagline:         'Learn',
            price:           '$0',
            priceMeta:       <>USD / year<br/>billed annually</>,
            pitch:           "Limited API Usage",
            pitchMeta:       '',
            featuresHeading: 'Feature heading placeholder:',
            features: [
                'Limited API Usage',
                '1x Limit on Intelligence Layer',
                '',
                '',
            ],
        },
        {
            upgradeCard:            true,
            graphic:         graphicPro,
            tierName:        'Pro Plan',
            tagline:         'Master',
            price:           'From $175',
            priceMeta:       <>USD / year<br/>billed annually</>,
            pitch:           "Unlimited API Usage",
            pitchMeta:       '',
            featuresHeading: 'Feature heading placeholder:',
            features: [
                'Unlimited API Usage',
                '20x Limit on Intelligence Layer',
                'Direct Access to Founder for New Companies & Features',
                '',
            ],
        },
    ]    
    
    // == functionality / logic ==
    const fetchStipeCheckoutSessionURL = async () => {
        try {
            setIsLoading(true)
            const url              = await handleFetchCheckoutSessionURL()
            console.log("[SUCCESS] STRIPE CHECKOUT SESSION URL: ", url)
            window.location.href   = url 

        } catch (error) {
            // need below soft guard optional chaining / conditional shape in error block because if request never reaches backend there is no response on the error object!
            // and therefore dot notationing into a prop that is undefined (response being undefined on the error object if it never reaches the backend and its a network error), as we know, is a syntax error and will break our front end app!
            console.error('✗ [ERROR] fetching stripe checkout session url:', error.response?.message)
            if (error.response?.status) console.error('✗ [STATUS]:', error.response.status)
        }
    }    

    // jsx helper functions
    const resolveSubscriptionCardStyle = (upgradeCard, isLoading) => {
        if ( !upgradeCard )              return ''
        if ( upgradeCard && !isLoading)  return 'animation'
        if ( upgradeCard && isLoading )  return ''
    }

        
    return (
        <div className="subscription-cards-content-container">
            { tiers.map((tier, i) => (
                <div key={i} className={`subscription-card ${resolveSubscriptionCardStyle(tier.upgradeCard, isLoading)}`}>

                    <div className="subscription-card-graphic">{ tier.graphic }</div>

                    <div className="subscription-card-tier-name">{ tier.tierName }</div>
                    <div className="subscription-card-tier-tagline">{ tier.tagline }</div>

                    <div className="subscription-card-price-row">
                        <span className="subscription-card-price">{ tier.price }</span>
                        <span className="subscription-card-price-meta">{ tier.priceMeta }</span>
                    </div>

                    { tier.upgradeCard 
                        ? <div className="subscription-card-pitch" disabled={isLoading} onClick={fetchStipeCheckoutSessionURL} > { isLoading ? <div className="loading-spinner loading-sm" /> : tier.pitch } </div>
                        : <div className="subscription-card-pitch" disabled                                                    > {tier.pitch}                                                                </div>
                    }

                    <div className="subscription-card-features">
                        <div className="subscription-card-features-heading">{ tier.featuresHeading }</div>
                        { tier.features.map((feature, j) => (
                            <div key={j} className="subscription-card-feature">
                                { feature && ( <> { checkIcon } <span>{ feature }</span> </> ) }
                            </div>
                        )) }
                    </div>

                </div>
            )) }
        </div>
    )

}

export default SubscriptionCards
